// extracted by mini-css-extract-plugin
export default {"container":"StageSelector_container__B13eW","buttonLeft":"StageSelector_buttonLeft__DlVkQ","buttonRight":"StageSelector_buttonRight__NRKAB"};